import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'join',
    standalone: true,
})
export class JoinPipe implements PipeTransform {
    transform(value: any[], key?: string): string {
        if (Array.isArray(value)) {
            if (key) {
                return value.map((item: any) => item[key]).join(', ');
            }
            return value.join(', ');
        }
        return '';
    }
}
